import type {
  FeatureHeroAlign,
  FeatureHeroHeadingTag,
} from "~/hec/components/organisms/feature-hero/types";

export const toHeadingTag = (value?: string): FeatureHeroHeadingTag =>
  value === "h1" || value === "h3" ? value : "h2";

export const toAlign = (value?: string): FeatureHeroAlign =>
  value === "center" || value === "right" ? value : "left";
